// Diccionario de strings de la consola — español por defecto (docs/05 §8).
// Sin literales en JSX: toda cadena visible sale de aquí.

export const es = {
  app: {
    name: "REMA Auth",
    consoleTagline: "Consola de administración",
  },
  nav: {
    dashboard: "Dashboard",
    users: "Usuarios",
    domains: "Dominios",
    roles: "Roles",
    scopes: "Scopes",
    nodes: "Nodos",
    clients: "Clients",
    audit: "Auditoría",
    settings: "Ajustes",
  },
  shell: {
    toggleNav: "Mostrar u ocultar navegación",
    themeToLight: "Cambiar a tema claro",
    themeToDark: "Cambiar a tema oscuro",
    userMenu: "Menú de usuario",
    profile: "Mi perfil",
    logout: "Cerrar sesión",
  },
  login: {
    title: "Iniciar sesión",
    subtitle: "Accede a la consola de administración",
    identifierLabel: "Usuario",
    identifierPlaceholder: "usuario.dominio (p. ej. admin.system)",
    passwordLabel: "Contraseña",
    submit: "Iniciar sesión",
  },
  validation: {
    identifierRequired: "Escribe tu usuario.",
    identifierFormat: "Formato esperado: usuario.dominio (p. ej. admin.system).",
    passwordRequired: "Escribe tu contraseña.",
  },
  errors: {
    invalid_credentials: "Usuario o contraseña incorrectos.",
    account_locked: "Cuenta bloqueada temporalmente. Inténtalo de nuevo más tarde.",
    domain_suspended: "El dominio está suspendido. Contacta con tu administrador.",
    mfa_required: "Esta cuenta requiere MFA, aún no disponible en la consola.",
    rate_limited: "Demasiados intentos. Espera un momento y vuelve a intentarlo.",
    network: "No se pudo conectar con el servidor. Revisa tu conexión.",
    unexpected: "Ocurrió un error inesperado. Inténtalo de nuevo.",
  },
  common: {
    loading: "Cargando…",
    retry: "Reintentar",
    cancel: "Cancelar",
    close: "Cerrar",
    save: "Guardar",
    loadMore: "Cargar más",
    loadError: "No se pudieron cargar los datos.",
    emptyTitle: "Aún no hay elementos",
  },
  stub: {
    title: "Módulo en construcción",
    description: "Esta sección estará disponible en una próxima fase.",
  },
  pages: {
    profile: "Mi perfil",
  },
} as const

// Mensaje legible para un código de error de la API; cae a `unexpected`.
export const errorMessage = (code: string): string => {
  const known = es.errors as Record<string, string | undefined>
  return known[code] ?? es.errors.unexpected
}
